export default {
  D: "#00639a",
  E: "#00639a",
};
